module.exports = __webpack_public_path__ + "img/hc_pro_night_6.a26bfb17.jpg";